/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetCouponPaymentsByAssetIdOptions,
  GetCouponPaymentsByAssetIdStatus200,
  GetCouponPaymentsByAssetIdStatus400,
  GetCouponPaymentsByAssetIdStatus404,
} from '../types/GetCouponPaymentsByAssetId'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCouponPaymentsByAssetId } from '../clients/getCouponPaymentsByAssetId'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCouponPaymentsByAssetIdQueryKey = ({
  path,
}: Omit<GetCouponPaymentsByAssetIdOptions, 'headers'>) =>
  [{ url: '/v1/assets/:asset_id/coupon_payments', params: path }] as const

type GetCouponPaymentsByAssetIdQueryKey = ReturnType<typeof getCouponPaymentsByAssetIdQueryKey>

export function getCouponPaymentsByAssetIdQueryOptions(
  { path }: GetCouponPaymentsByAssetIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getCouponPaymentsByAssetIdQueryKey({ path })
  return queryOptions<
    GetCouponPaymentsByAssetIdStatus200,
    ResponseErrorConfig<GetCouponPaymentsByAssetIdStatus400 | GetCouponPaymentsByAssetIdStatus404>,
    GetCouponPaymentsByAssetIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getCouponPaymentsByAssetId({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get coupon payments for a bond asset
 * {@link /v1/assets/:asset_id/coupon_payments}
 */
export function useGetCouponPaymentsByAssetId<
  TData = GetCouponPaymentsByAssetIdStatus200,
  TQueryData = GetCouponPaymentsByAssetIdStatus200,
  TQueryKey extends QueryKey = GetCouponPaymentsByAssetIdQueryKey,
>(
  {
    path,
  }: {
    path:
      | GetCouponPaymentsByAssetIdOptions['path']
      | (() => GetCouponPaymentsByAssetIdOptions['path'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCouponPaymentsByAssetIdStatus200,
        ResponseErrorConfig<
          GetCouponPaymentsByAssetIdStatus400 | GetCouponPaymentsByAssetIdStatus404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getCouponPaymentsByAssetIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getCouponPaymentsByAssetIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetCouponPaymentsByAssetIdStatus400 | GetCouponPaymentsByAssetIdStatus404>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
